import React from "react";
import styled from "styled-components";
import VirginiaImage from "../../assets/virginia.png";
import Pulse from "../components/atoms/Pulse";
import { HideMobile, ShowMobile } from "../components/blocks/Responsive";
import { r } from "../utils";

export const VirginiaHero = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;
  padding-top: 2rem;
  padding-bottom: 0;
  .intro {
    max-width: 42rem;
  }
  @media (max-width: 1100px) {
    padding-bottom: 18rem;
  }
  @media (max-width: 720px) {
    padding-bottom: 10rem;
  }
`;
const VirginiaWrapper = styled.div`
  width: 40rem;
  position: absolute;
  right: 0;
  padding-top: 2rem;
  @media (max-width: 1100px) {
    bottom: 0;
    opacity: .8;
    right: 0;
  }
  @media (max-width: 720px) {
    width: 100%;
  }
`;

export default () =>
  <VirginiaWrapper>
    <img
      src={VirginiaImage}
      alt={"Charlottesville is a beautiful place to live and work."}
      style={{ width: "100%" }}
    />

    <ShowMobile>
      <Pulse top="53.66%" right="39.3%" />
    </ShowMobile>
    <HideMobile>
      <Pulse top="10.407rem" right="15.955rem" />
    </HideMobile>
  </VirginiaWrapper>;



// WEBPACK FOOTER //
// ./src/components/Virginia.js